import React, { useEffect, useState } from "react";
import { usePinCode } from "../../Pregrine/PinCode/usePinCode";
import classes from "./PinCodeCheck.module.css";

const PinCodeCheck = (props) => {
  const {
    openPinCodeModal,
    pinCodeCheckFun,
    handlePinCodeModal,
    product,
    setPincodeDataFromModal,
  } = props;
  const [pinCode, setPinCode] = useState("");
  const [pinCodeError, setPinCodeError] = useState(null);

  const talonProps = usePinCode({
    setPincodemessage: setPinCodeError,
    pinCodeCheckFun,
    pinCode,
  });
  const { checkPinCode, pincodeData } = talonProps;

  const PinCodeCheckPerform = async () => {
    if (pinCode && pinCode.length != 6) {
      setPinCodeError("Please enter valid PinCode");
    } else if (!pinCode) {
      setPinCodeError("Please enter valid PinCode");
    } else {
      setPinCodeError(null);
      await checkPinCode({
        variables: { pinCode: pinCode, sku: product.sku },
      });
    }
  };

  useEffect(() => {
    if (setPincodeDataFromModal && pincodeData) {
      setPincodeDataFromModal(pincodeData);
    }
  }, [pincodeData]);

  return (
    <div
      className={
        !openPinCodeModal
          ? classes.pincodecheckComponentClosed
          : classes.pincodecheckComponentOpen
      }
    >
      <div className={classes.pincodeCheckBox}>
        <div className={classes.pincodeCheckinner}>
          <div className={classes.inputSection}>
            <input
              type="number"
              id="pincode"
              name="pincode"
              onChange={(e) => setPinCode(e.target.value)}
              defaultValue={""}
              placeholder={"Enter PinCode to check availability*"}
            />
          </div>
          <button className="btn btn-secondary" onClick={handlePinCodeModal}>
            Cancel
          </button>
          <button
            className="btn btn-danger"
            onClick={() => PinCodeCheckPerform()}
          >
            Check
          </button>
          <div className={classes.pinCodeError}>
            <span>{pinCodeError}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PinCodeCheck;
